// Create a function to check if the user is authenticated
export function isUserAuthenticated() {
    const session = localStorage.getItem('userObj')
    if (session) {
        return true
    } else {
        return false
    }
}

